import { translate } from '@openclassrooms/translations';
import error503src from '@classify/illustrations/error503';

import ErrorWrapper from '../components/ErrorWrapper';

import useStyles from './useStyles';

const Error503 = (props) => {
  const classes = useStyles();
  return (
    <ErrorWrapper
      classes={classes}
      httpStatus={503}
      pictureUrl={error503src}
      pictureWidth={400}
      titleLabel={translate('errors.error503.overload.title')}
      detailsLabel={translate('errors.error503.overload.subtitle')}
      {...props}
    />
  );
};

export default Error503;
